const Icon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.61 242.71" {...props}>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        fill="currentColor"
                        d="M221.22,132.57c-9.54.84-19.11,1.44-28.62,2.6s-19.13,2.63-28.62,4.37c-26.64,4.87-42,21.15-46.24,47.6-2.65,16.59-4.17,33.36-6.17,50.05-.21,1.8-.25,3.62-1.37,5.52-.5-5.9-.76-11.84-1.55-17.7-1.91-14.18-3.45-28.44-6.25-42.46-4.65-23.31-19.13-37.9-42.48-42.21-17.64-3.26-35.59-4.88-53.4-7.18-2.12-.27-4.29-.24-6.52-1.43,6.07-.51,12.17-.81,18.21-1.57,12.88-1.61,25.79-3.06,38.57-5.3,26.82-4.69,42.48-21,46.72-47.7,2.64-16.59,4.17-33.36,6.17-50,.21-1.8.24-3.62,1.36-5.52.5,5.92.77,11.86,1.56,17.74,1.88,14,3.43,28.11,6.14,42,4.65,23.76,19.3,38.5,43.1,42.78,17.66,3.17,35.59,4.81,53.41,7.09,2,.25,3.95.22,5.92.31Z"
                    />
                    <path
                        fill="currentColor"
                        d="M238.61,45.29c-3.89.34-7.8.59-11.68,1.06s-7.81,1.07-11.68,1.78c-10.87,2-17.15,8.63-18.87,19.43-1.08,6.77-1.7,13.61-2.52,20.43a5.22,5.22,0,0,1-.56,2.25c-.2-2.41-.31-4.83-.63-7.22-.78-5.79-1.41-11.61-2.55-17.33-1.9-9.52-7.81-15.47-17.34-17.23-7.2-1.33-14.52-2-21.79-2.93a7.06,7.06,0,0,1-2.66-.58c2.48-.21,5-.33,7.43-.64,5.26-.66,10.53-1.25,15.74-2.16,10.95-1.92,17.34-8.57,19.07-19.47,1.07-6.77,1.7-13.62,2.52-20.43A5.17,5.17,0,0,1,193.64,0c.21,2.41.32,4.84.64,7.24.76,5.72,1.4,11.47,2.5,17.13,1.9,9.69,7.88,15.71,17.59,17.46,7.21,1.29,14.53,2,21.8,2.89.8.1,1.61.09,2.42.13Z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Icon;
